import React from 'react';
import DhcpOff from "../../../assets/images/dhcpOff.png";
import Rede2 from "../../../assets/images/rede2.png";
import Wifi2 from "../../../assets/images/wifi2.png";
import Wifi2Security from "../../../assets/images/wifi2Security.png";
import Wifi5 from "../../../assets/images/wifi5.png";
import Wifi5Security from "../../../assets/images/wifi5Security.png";
import Reiniciar from "../../../assets/images/reiniciar.png";


import './styles.css';

const ModoBridge = () => {


    return (
        <>
            <div className="content">
                <h1>Cenário II Roteador em modo Bridge</h1>
                <span>
                    A figura abaixo ilustra a configuração mais utilizada para residências, desabilitamos o servidor DHCP e não utilizamos o porta WAN do roteador.
                </span>
                <div className="rede1">
                    <img src={Rede2} alt="dns" />
                </div>
                <br />
                <p>Essa configuração é mais simples, pois não precisamos nos preocupar com a conexão WAN, que não será utilizada.<br />
                    Algumas configurações são identicas aos da configuração anterior. Como não vamos utilizar a porta
                    WAN partimos direto para a configuração da rede Wi-Fi</p>
                <br /><br />
                
                <p>Configurando o SSID da Wi-FI 2.4GHz</p>
                <br />
                <div className="wifi2">
                    <img src={Wifi2} alt="wifi2" />
                </div>
                <br />
                <p>Configurando a Segurançada Wi-FI 2.4GHz</p>
                <div className="wifi2">
                    <img src={Wifi2Security} alt="wifi2" />
                </div>
                <br />
                <p>Configurando o SSID da Wi-FI 5GHz</p>
                <div className="wifi5">
                    <img src={Wifi5} alt="wifi5" />
                </div>
                <br />
                <p>Configurando a Segurança da Wi-FI 5GHz</p>
                <div className="wifi5">
                    <img src={Wifi5Security} alt="wifi5" />
                </div>
                <br />
                <p>Desabilitando o servidor DHCP</p>
                <div className="dns">
                    <img src={DhcpOff} alt="dns" />
                </div>
                <br />
                <p>Reinicie o roteador, conecte o cabo de rede na porta 1 da ONU na porta LAN1 do roteador. Realize um teste de navagação com o celular para verificar se as configurações foram aplicadas corretamente.</p>
                <div className="dns">
                    <img src={Reiniciar} alt="dns" />
                </div>
            </div>
        </>
    );
};

export default ModoBridge;
